import { type QTableColumn } from 'quasar'
import { Color } from '@previo/codebooks'
import { SortDir } from '@previo/core'

// Canonical SortDir lives in @previo/core; re-exported here so existing
// `import { SortDir } from '@previo/design-system'` call sites keep working.
export { SortDir }

/**
 * @deprecated
 */
export type PDataTableColumns = PDataTableColumn

export type PDataTableColumn = Omit<QTableColumn, 'rawSort' | 'sortOrder' | 'style'> & {
  width?: string
  minWidth?: string
  maxWidth?: string
  hidden?: () => boolean
  widthMobile?: string
  resizable?: boolean
}

export type PDataTableColumnName = PDataTableColumn['name']

export type PDataTableRow = Record<string, any>

export type PDataTableRowKey = string
export type PDataTableRowIdValue = number | string | symbol

export type PDataTableRowBackgroundColorFn<T extends PDataTableRow> = (
  row: T,
) => Color | null | undefined

export enum PDataTableSeparator {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
  CELL = 'cell',
  NONE = 'none',
}

export type PDataTablePaginationType = {
  sortBy: string | null
  sortDir: SortDir
  page: number
  rowsPerPage: number
  rowsNumber: number
}

export type PDataTableRequest = {
  pagination: PDataTablePaginationType
  filter?: any
  getCellValue: (col: any, row: any) => any
}

/**
 * Public type of a `PDataTable` component instance (its exposed methods).
 *
 * Use this instead of `InstanceType<typeof PDataTable>` when typing a template
 * ref to a `PDataTable`: because `PDataTable` is a generic SFC
 * (`<script setup generic="T extends PDataTableRow">`), `InstanceType<>` does
 * not work on it. Mirrors `PDataTable`'s `defineExpose`.
 */
export type PDataTableComponent = {
  requestServerInteraction: () => void
  scrollToRows: (rowIds: PDataTableRowIdValue[]) => void
  showColumnsToggleContextMenu: () => void
  collapseAllExpandedRows: () => void
  expandAllCollapsedRows: () => void
  expandRows: (rowIds: PDataTableRowIdValue[]) => void
  expandRow: (rowId: PDataTableRowIdValue) => void
  toggleRow: (rowId: PDataTableRowIdValue) => void
  resetColumnSettings: () => void
  visibleColumnsInOrder: PDataTableColumnName[]
}
